import { render, staticRenderFns } from "./CurrencyInvestList.vue?vue&type=template&id=ad1a502a&scoped=true"
import script from "./CurrencyInvestList.vue?vue&type=script&lang=js"
export * from "./CurrencyInvestList.vue?vue&type=script&lang=js"
import style0 from "./CurrencyInvestList.vue?vue&type=style&index=0&id=ad1a502a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1a502a",
  null
  
)

export default component.exports